import { supabase } from "@/integrations/supabase/client";

export const TRIAL_LENGTH_MS = 7 * 24 * 60 * 60 * 1000;

export type PremiumProfileFields = {
  is_premium?: boolean | null;
  bypass_rate_limit?: boolean | null;
  trial_ends_at?: string | null;
  is_coach?: boolean | null;
};

export const getSevenDayTrialEnd = () => new Date(Date.now() + TRIAL_LENGTH_MS).toISOString();

export const isTrialActive = (trialEndsAt?: string | null) => {
  if (!trialEndsAt) return false;
  const endsAt = new Date(trialEndsAt).getTime();
  return Number.isFinite(endsAt) && endsAt > Date.now();
};

export const hasActivePremiumAccess = (profile?: PremiumProfileFields | null) => {
  if (!profile) return false;
  return (
    profile.bypass_rate_limit === true ||
    profile.is_premium === true ||
    profile.is_coach === true ||
    isTrialActive(profile.trial_ends_at)
  );
};

export const hasActiveCoachAccess = (profile?: PremiumProfileFields | null) => {
  if (!profile) return false;
  return profile.bypass_rate_limit === true || profile.is_coach === true;
};

export const fetchPremiumAccess = async (userId: string) => {
  const { data, error } = await supabase
    .from("profiles")
    .select("is_premium, bypass_rate_limit, trial_ends_at, is_coach")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.error("Error fetching premium status:", error);
  }

  return {
    isPremium: hasActivePremiumAccess(data),
    isBypass: data?.bypass_rate_limit === true,
    isCoach: hasActiveCoachAccess(data),
    trialEndsAt: data?.trial_ends_at ?? null,
  };
};

export const notifyPremiumStatusChanged = () => {
  window.dispatchEvent(new Event("premium-status-changed"));
};
